import React from 'react';
import { Button, Col, Form, Row, Modal } from "react-bootstrap";
import NumericInput from 'react-numeric-input';
import { currencyFormat, toastMessage } from './../../Common/Common';
import * as code from './../../../config/Constants';

const period = [
    { value: "month", label: "Monthly"},
    { value: "year", label: "Yearly"},
]
class PriceInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            amount: '',
            billingPeriod: '',
            priceDescription: '',
            priceInformation: props.getSubscriptionData().priceInformation || [],
            showPriceErr: false,
            showIntervalErr: false,
            isActive: true,
            isEdit: false,
            editIndex: '',
            editPriceModal: false,
            edt_amount: '',
            edt_billingPeriod: '',
            edt_priceDescription: '',
            edtIsActive: true,
            edtPriceErr: false,
            edtIntervalErr: false,
        };
    }

    renderHelpText(message, id) {
        return (<div className="val-err-tooltip" key={id}><span>{message}</span></div>);
    }
    onChange(event) {
        if (event.target.name === "isActive" || event.target.name === "edtIsActive") {
            this.setState({ [event.target.name]: event.target.checked });
        } else {
            this.setState({ [event.target.name]: event.target.value });
        }
        this.props.updateSubscriptionData(event.target.name, event.target.value);
        if (event.target.name === 'amount' && event.target.value !== '') {
            this.setState({ showPriceErr: false })
        }
        if (event.target.name === 'billingPeriod' && event.target.value !== '') {
            this.setState({ showIntervalErr: false })
        }
        if (event.target.name === 'edt_amount' && event.target.value !== '') {
            this.setState({ edtPriceErr: false })
        }
        if (event.target.name === 'edt_billingPeriod' && event.target.value !== '') {
            this.setState({ edtIntervalErr: false })
        }
    }
    /**
        * @desc get error message based on field
        * @param {*} field 
        */
    getErrorMsg(field) {
        var err = '';

        if (field === "amount" || field === "edt_amount") {
            err = 'Please enter Price';
        }
        if (field === "billingPeriod" || field === "edt_billingPeriod") {
            err = 'Please select billing period';
        }

        return err;
    }
    addPrice() {
        if (this.state.amount !== '' && this.state.billingPeriod !== '') {
            let newPrice = { currency: "USD", unit_amount: this.state.amount, recurring: { interval: this.state.billingPeriod }, priceDescription: this.state.priceDescription, isActive: this.state.isActive };
            let priceInfo = this.state.priceInformation;
            let obj = priceInfo.find(o => o.recurring.interval === this.state.billingPeriod && o.isActive);
            if(!!obj && Object.keys(obj).length > 0 && this.state.isActive){
                toastMessage(code.ERROR,"Cannot add multiple active price with same billing period")
            }else{
            priceInfo.push(newPrice);
            this.setState({ priceInformation: priceInfo, amount: '', billingPeriod: '', priceDescription: '', isActive: true });
            this.setState({ showPriceErr: false, showIntervalErr: false })
            this.props.updateSubscriptionData("priceInformation", priceInfo);
            
        }
        } else {
            this.showHideError();
        }
    }
    showHideError() {
        if (!this.state.isEdit) {
            if (this.state.amount === '' && this.state.billingPeriod === '') {
                this.setState({ showPriceErr: true, showIntervalErr: true })
            } else if (this.state.amount === '') {
                this.setState({ showPriceErr: true })
            } else if (this.state.billingPeriod === '') {
                this.setState({ showIntervalErr: true })
            } else if (this.state.amount !== '') {
                this.setState({ showPriceErr: false })
            } else if (this.state.billingPeriod !== '') {
                this.setState({ showIntervalErr: false })
            }
        } else {
            if (this.state.edt_amount === '' && this.state.edt_billingPeriod === '') {
                this.setState({ edtPriceErr: true, edtIntervalErr: true })
            } else if (this.state.edt_amount === '') {
                this.setState({ edtPriceErr: true })
            } else if (this.state.edt_billingPeriod === '') {
                this.setState({ edtIntervalErr: true })
            } else if (this.state.edt_amount !== '') {
                this.setState({ edtPriceErr: false })
            } else if (this.state.edt_billingPeriod !== '') {
                this.setState({ edtIntervalErr: false })
            }
        }
    }
    /**
      * @desc remove price using price index
      * @param {*} priceInd 
      */
    removePrice(priceInd) {
        var priceArr = this.state.priceInformation;
        if (priceInd !== "") {
            priceArr.splice(priceInd, 1);
            this.setState({ priceInformation: priceArr });
        }
    }
    /**
     * @desc edit price using price index
     * @param {*} priceInd 
     */
    editPrice(priceInd) {
        this.setPriceModal();
        this.setState({ isEdit: true, editIndex: priceInd });
        let priceArr = this.state.priceInformation;
        let priceInfo = priceArr[priceInd];

        if (priceInd !== "") {
            this.setState({ edt_amount: priceInfo.unit_amount, edt_billingPeriod: priceInfo.recurring.interval, edt_priceDescription: priceInfo.priceDescription, edtIsActive: priceInfo.isActive });
            this.setState({ edtPriceErr: false, edtIntervalErr: false });
        }
    }
    updatePrice() {
        if (this.state.edt_amount !== '' && this.state.edt_billingPeriod !== '') {
            let priceInfo = this.state.priceInformation;
            let obj = priceInfo.find((o,i) => o.recurring.interval === this.state.edt_billingPeriod && o.isActive && i !== this.state.editIndex);
            if(!!obj && Object.keys(obj).length > 0 && this.state.edtIsActive && priceInfo.length >1){
                toastMessage(code.ERROR,"Cannot add multiple active price with same billing period")
            }else{
            priceInfo[this.state.editIndex].unit_amount = this.state.edt_amount;
            priceInfo[this.state.editIndex].recurring.interval = this.state.edt_billingPeriod;
            priceInfo[this.state.editIndex].priceDescription = this.state.edt_priceDescription;
            priceInfo[this.state.editIndex].isActive = this.state.edtIsActive;
            this.setState({ showPriceErr: false, showIntervalErr: false });
            this.props.updateSubscriptionData("priceInformation", priceInfo);
            this.setState({ priceInformation: priceInfo, edt_amount: '', edt_billingPeriod: '', edt_priceDescription: '', edtIsActive: true, isEdit: false, editIndex: '' });
            this.setPriceModal();
            }

        } else {
            this.showHideError();
        }
    }
    cancelPrice() {
        this.setPriceModal();
        this.setState({ edt_amount: '', edt_billingPeriod: '', edt_priceDescription: '', edtIsActive: true, isEdit: false, editIndex: '' });

    }
    setPriceModal() {
        this.setState({ editPriceModal: !this.state.editPriceModal, isEdit: false });
    }
    render() {
        if (this.state.showLoader) {

            return (<div className="page-loader fixed">
                <div className="page-loader-inner">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            </div>)

        } else {

            return (
                <div className="admin-steps last-step admin-content-area campaign-step">

                    <div className="container-custom">
                        <Form className="form-sm form-admin">
                            <Row>
                                <Col xs={12}><h4 className="title-small font-600 mt-2 mb-3 pt-3">Price Information</h4></Col>
                            </Row>


                            <Row>
                                <Col xs={12} sm={12} className="subscription-price-info mb-2">
                                    <div className="rsp-table">
                                        <div className="rsp-tab-group">
                                            <div className="rsp-row rsp-header">
                                                <div className="rsp-cell">Price</div>
                                                <div className="rsp-cell" style={{ width: "20%" }}>Billing Period</div>
                                                <div className="rsp-cell" style={{ width: "60%" }}>Price Description</div>
                                                <div className="rsp-cell" >Status</div>
                                                <div className="rsp-cell center">Action</div>
                                            </div>
                                        </div>
                                        {this.state.priceInformation.length > 0 ?
                                            this.state.priceInformation.map((price, ind) => {
                                                return (
                                                    <div className="rsp-tab-group">
                                                        <div class="rsp-row">
                                                            <div className="rsp-cell" data-title="Price">{currencyFormat(price.unit_amount)}</div>
                                                            <div className="rsp-cell" data-title="Billing Period">{price.recurring.interval === 'month' ? "Monthly" : "Yearly"}</div>
                                                            <div className="rsp-cell" data-title="Price Description" style={{ width: "70%" }}>{price.priceDescription}</div>
                                                            <div className="rsp-cell" data-title="Status">{price.isActive ? "Active" : "Deactive"}</div>
                                                            <div className="rsp-cell center" data-title="Action">
                                                                <span className="rsp-action-btn" onClick={() => { this.editPrice(ind) }}><i class="fa fa-pencil" aria-hidden="true"></i></span>
                                                            {price._id === undefined ?
                                                                <span className="rsp-action-btn"  onClick={() => this.removePrice(ind)}><i aria-hidden="true" class="fa fa-trash-o"></i></span> : ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            }) :
                                            <div className="rsp-tab-group no-price">
                                                <div class="rsp-row">
                                                    <div className="rsp-cell">No price information found</div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <Form.Group controlId="">
                                        <Form.Label>Price<span className="text-danger">*</span></Form.Label>

                                        <NumericInput
                                            name="amount"
                                            inputMode="numeric"
                                            strict
                                            step={0.1} precision={2}
                                            style={false}
                                            maxLength={9}
                                            className='form-control text-right sales-input'
                                            value={this.state.amount}
                                            onChange={(e) => {
                                                this.setState({ amount: e });
                                            }}
                                        />
                                        {this.state.showPriceErr ?
                                            <Form.Text className="text-danger">
                                                {this.renderHelpText(this.getErrorMsg('amount'))}
                                            </Form.Text> : ""}
                                    </Form.Group>

                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12} sm={6}>
                                    <Form.Group controlId="">
                                        <Form.Label>Billing period<span className="text-danger">*</span></Form.Label>
                                        <div className="c-select">
                                            <select name="billingPeriod" className="form-control"
                                                value={this.state.billingPeriod}
                                                onChange={this.onChange.bind(this)}
                                            >
                                                <option value="">Select</option>
                                                {
                                                    period.map(e => {
                                                        return <option value={e.value} >{e.label}</option>
                                                    })
                                                }
                                            </select>
                                        </div>
                                        {this.state.showIntervalErr ?
                                            <Form.Text className="text-danger">
                                                {this.renderHelpText(this.getErrorMsg('billingPeriod'))}
                                            </Form.Text> : ""}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <Form.Group controlId="">
                                        <Form.Label>Price description</Form.Label>
                                        <Form.Control type="text" name="priceDescription"
                                            value={this.state.priceDescription}
                                            className="field_ucfirst"
                                            onChange={this.onChange.bind(this)}
                                            maxLength={250}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col >
                                    <div className="custom-control custom-checkbox custom-control-inline font-600">
                                        <input type="checkbox" className="custom-control-input"
                                            id="checkActive" name="isActive" onChange={this.onChange.bind(this)}
                                            checked={this.state.isActive} />
                                        <label className="custom-control-label" htmlFor="checkActive">Active</label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <Button variant="primary" size="sm" className="subscription-add-price" onClick={() => this.addPrice()}><span>+</span> Add price</Button>
                                </Col>
                            </Row>

                        </Form>
                    </div>
                    {/* Edit price modal */}
                    <Modal
                        show={this.state.editPriceModal}
                        onHide={() => this.setPriceModal()}
                        dialogClassName="modal-90w"
                        aria-labelledby="example-custom-modal-styling-title"
                        className="modal-med1 edit-subscription-pop">

                        <Form className="form-sm form-admin">
                            <Modal.Header closeButton>
                                <Modal.Title id="example-custom-modal-styling-title">
                                    Edit
								</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Row>
                                    <Col xs={12} sm={6}>
                                        <Form.Group controlId="">
                                            <Form.Label>Price<span className="text-danger">*</span></Form.Label>

                                            <NumericInput
                                                name="edt_amount"
                                                inputMode="numeric"
                                                strict
                                                step={0.1} precision={2}
                                                style={false}
                                                maxLength={9}
                                                className='form-control text-right sales-input'
                                                value={this.state.edt_amount}
                                                onChange={(e) => {
                                                    this.setState({ edt_amount: e });
                                                }}
                                                readOnly={!!this.state.priceInformation && this.state.editIndex !== '' && this.state.priceInformation[this.state.editIndex]._id != undefined  ? true : false}
                                            />
                                            {this.state.edtPriceErr ?
                                                <Form.Text className="text-danger">
                                                    {this.renderHelpText(this.getErrorMsg('edt_amount'))}
                                                </Form.Text> : ""}
                                        </Form.Group>

                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={12} sm={6}>
                                        <Form.Group controlId="">
                                            <Form.Label>Billing period<span className="text-danger">*</span></Form.Label>
                                            <div className="c-select">
                                                <select name="edt_billingPeriod" className="form-control"
                                                    value={this.state.edt_billingPeriod}
                                                    onChange={this.onChange.bind(this)}
                                                    disabled={!!this.state.priceInformation && this.state.editIndex !== '' && this.state.priceInformation[this.state.editIndex]._id != undefined  ? true : false}
                                                >
                                                    <option value="">Select</option>
                                                    {
                                                        period.map(e => {
                                                            return <option value={e.value}>{e.label}</option>
                                                        })
                                                    }
                                                </select>
                                            </div>
                                            {this.state.edtIntervalErr ?
                                                <Form.Text className="text-danger">
                                                    {this.renderHelpText(this.getErrorMsg('edt_billingPeriod'))}
                                                </Form.Text> : ""}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={12}>
                                        <Form.Group controlId="">
                                            <Form.Label>Price description</Form.Label>
                                            <Form.Control type="text" name="edt_priceDescription"
                                                value={this.state.edt_priceDescription}
                                                className="field_ucfirst"
                                                onChange={this.onChange.bind(this)}
                                                maxLength={250}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col >
                                        <div className="custom-control custom-checkbox custom-control-inline font-600">
                                            <input type="checkbox" className="custom-control-input"
                                                id="checkEdtActive" name="edtIsActive" onChange={this.onChange.bind(this)}
                                                checked={this.state.edtIsActive} />
                                            <label className="custom-control-label" htmlFor="checkEdtActive">Active</label>
                                        </div>
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant='primary' className="btn-blue btn-outlined w-140" onClick={() => this.cancelPrice()}>Cancel</Button>
                                <Button variant='primary' className="btn-blue w-140" onClick={() => this.updatePrice()}>Save</Button>
                            </Modal.Footer>

                        </Form>
                    </Modal>

                </div >

            );
        }

    }
}

export default (PriceInfo);



